/**
 * Converts a Congress API bill or amendment URL to the public Congress.gov page URL.
 * 
 * Examples:
 * Bill input:      "https://api.congress.gov/v3/bill/119/hr/2192?format=json"
 * Bill output:     "https://www.congress.gov/bill/119th-congress/house-bill/2192"
 *
 * Amendment input: "https://api.congress.gov/v3/amendment/118/hamdt/998?format=json"
 * Amendment output:"https://www.congress.gov/amendment/118th-congress/house-amendment/998"
 */
export function getCongressBillPageUrl(apiUrl: string): string {
    // Handle amendments
    const amendmentRegex = /\/amendment\/(\d+)\/(hamdt|samdt)\/(\d+)/i;
    const amendmentMatch = apiUrl.match(amendmentRegex);

    if (amendmentMatch) {
        const congressNumber = amendmentMatch[1];
        const amendmentType = amendmentMatch[2].toLowerCase();
        const amendmentNumber = amendmentMatch[3];

        const amendmentTypeMap: Record<string, string> = {
            hamdt: "house-amendment",
            samdt: "senate-amendment",
        };

        const mappedAmendmentType = amendmentTypeMap[amendmentType];
        if (!mappedAmendmentType) return '';

        return `https://www.congress.gov/amendment/${congressNumber}th-congress/${mappedAmendmentType}/${amendmentNumber}`;
    }

    // Handle bills
    const billRegex = /\/bill\/(\d+)\/(hr|s|sjres|hjres|hres|sres)\/(\d+)/i;
    const billMatch = apiUrl.match(billRegex);

    if (billMatch) {
        const congressNumber = billMatch[1];
        const billType = billMatch[2].toLowerCase();
        const billNumber = billMatch[3];

        const billTypeMap: Record<string, string> = {
            hr: "house-bill",
            s: "senate-bill",
            hjres: "house-joint-resolution",
            sjres: "senate-joint-resolution",
            hres: "house-resolution",
            sres: "senate-resolution",
        };

        const mappedType = billTypeMap[billType];
        if (!mappedType) return '';

        return `https://www.congress.gov/bill/${congressNumber}th-congress/${mappedType}/${billNumber}`;
    }

    return '';
}
